import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModel } from 'src/app/models/paginationModel';
import { OkHtmlModalComponent } from 'src/app/generic-components/ok-html-modal/ok-html-modal.component';
import { ViewNotificationComponent } from '../view-notification/view-notification.component';

@Component({
    selector: 'app-approve-notification',
    templateUrl: './approve-notification.component.html',
    styleUrls: ['./approve-notification.component.css'],
    providers: [NgxSpinnerService]
})

export class ApproveNotificationComponent implements OnInit {
    checkedNotifications = [];
    modalOptions: NgbModalOptions = {};
    scrHeight:any;
    scrWidth:any;
    //Approvers users table
    approver = false;
    displayedColumns: string[] = ['check', 'message', 'userGroup', 'sentBy', 'sentDate', 'scheduled', 'action'];
    dataSource:any = new MatTableDataSource<any>();
    totalLength = 0;
    active = "SentDate";
    direction = "ASC";
    pageIndex = 0;
    pageSize = 5;
    @ViewChild('Sort', {static: true}) sort: MatSort;
    @ViewChild('Paginator', {static: true}) paginator: MatPaginator;

    constructor(
        public functionsService: FunctionsService,
        private apiService: ApiService,
        private modalService: NgbModal,
        private pagination: PaginationModel,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private router: Router) { 
            this.functionsService.setTitle('breadcrumb.approve-notifications');
            this.approverCheck();
        }

    ngOnInit(){
        this.getScreenSize();
        this.dataSource.sort = this.sort;
        this.fetchUnapprovedNotifications();
        this.modalOptions.backdrop = 'static';
        this.modalOptions.keyboard = false;
        this.modalOptions.size = 'lg';
        this.translate.onLangChange.subscribe(() => 
            {   
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                }
            }
        );
    }

    fetchUnapprovedNotifications(){
        this.spinner.show();
        this.pagination.Page = this.pageIndex;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy =this.active;
        this.pagination.Order =this.direction;
        this.apiService.getUnapprovedNotifications(this.pagination).subscribe(
            resp => {
                var checkbox = <HTMLInputElement>document.getElementById('checkAllNotis');
                if(checkbox&&checkbox.checked){
                    checkbox.checked = false;
                }
                this.dataSource.data = Object.values(resp)[0];
                this.totalLength = parseInt(Object.keys(resp)[0]);
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    private approverCheck(){
        this.apiService.isApprover().subscribe(
            data => {
                if(data){
                    this.approver = true;
                }else{
                    this.router.navigateByUrl("/");
                }
            },
            error => {
                this.spinner.hide();
                this.router.navigateByUrl("/");
            }
        );
    }

    nextPage(evt){
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.fetchUnapprovedNotifications();
    }

    sortData(evt){
        this.active = evt.active;
        this.direction = evt.direction;
        this.fetchUnapprovedNotifications();
    }

    checkAllNotis() {
        var checkbox = <HTMLInputElement>document.getElementById('checkAllNotis');
        var checkboxes = document.getElementsByName('selectedNotis');
        var approverDisabled = false;
        for(var i=0, n=checkboxes.length;i<n;i++) {
            approverDisabled = (<HTMLInputElement>document.getElementById(checkboxes[i].id.toString())).disabled;
            if((checkbox.checked)&&(!approverDisabled))
            {
                if(!this.checkedNotifications.includes(checkboxes[i].id.toString())){
                    this.checkedNotifications.push(checkboxes[i].id.toString());
                }
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = true;
            }
            else{
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = false;
            }
        }

        if(!checkbox.checked){
            this.checkedNotifications = [];
        }
    }

    selectNoti(id){
        var checkbox = <HTMLInputElement>document.getElementById('checkAllNotis');
        if((<HTMLInputElement>document.getElementById(id)).checked){
            if(!this.checkedNotifications.includes(id.toString())){
                this.checkedNotifications.push(id.toString());
            }
        }
        else 
        {
            const index: number = this.checkedNotifications.indexOf(id.toString());
            if (index !== -1) {
                this.checkedNotifications.splice(index, 1);
            }  
        }
        checkbox.checked = false; 
    }

    approveSelected(approve){
        if(this.checkedNotifications.length>0)
        {
            const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
            if(approve){
                confirmModalRef.componentInstance.title = this.translate.instant('notification.approve_notifications');
                confirmModalRef.componentInstance.message = this.translate.instant('notification.approve_notifications_prompt');
            }else{
                confirmModalRef.componentInstance.title = this.translate.instant('notification.deny_notifications');
                confirmModalRef.componentInstance.message = this.translate.instant('notification.deny_notifications_prompt');
            }
            
            confirmModalRef.result.then(confirmed => {
                if (confirmed) {
                    this.spinner.show();
                    //Approve/Deny selected notifications
                    this.apiService.changeSelectedNotificationsStatus(this.checkedNotifications,approve).subscribe(
                        data => {
                            if(data.toString().includes("_reviewed_")){
                                const modalRef = this.modalService.open(OkHtmlModalComponent, { size: 'lg' });
                                modalRef.componentInstance.title = this.translate.instant("notification.reviewed");
                                var formattedMsg = data.toString().replace(new RegExp('_reviewed_', 'g'),'');
                                modalRef.componentInstance.message = this.translate.instant("notification.reviewed_noti")+formattedMsg;
                            }
                            this.checkedNotifications = [];
                            (<HTMLInputElement>document.getElementById('checkAllNotis')).checked = false;
                            this.spinner.hide();
                            this.fetchUnapprovedNotifications();
                        },
                        error => {
                            this.functionsService.errorHandler(error["status"]);
                            this.spinner.hide();
                        }
                    );
                }
            });
        }
        else {
            var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
            modalRef.componentInstance.title = this.translate.instant('Error');
            modalRef.componentInstance.message = this.translate.instant('notification.no_notifications');

            modalRef.result.then(() => {
                this.modalService.dismissAll();
            });
        }
    }

    viewNotification(id) {
            this.spinner.show();
            this.router.navigateByUrl('/main/notifications/view-notification/'+id);
            this.spinner.hide();
    }

    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['check', 'message', 'userGroup', 'sentBy', 'sentDate', 'scheduled', 'action'];
        if(this.scrWidth <= 912){
            this.displayedColumns = ['check', 'message', 'action'];
        }
        else if(this.scrWidth <= 1070){
            this.displayedColumns = ['check', 'message', 'scheduled', 'action'];
        }
        else if(this.scrWidth <= 1235){
            this.displayedColumns = ['check', 'message', 'userGroup', 'scheduled', 'action'];
        }
    }
}
